import { render, staticRenderFns } from "./OtderAppraise.vue?vue&type=template&id=1fd279dd&"
import script from "./OtderAppraise.vue?vue&type=script&lang=js&"
export * from "./OtderAppraise.vue?vue&type=script&lang=js&"
import style0 from "./OtderAppraise.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports